import React from 'react';
import styles from './DpgTemplateExamples.module.css';

function DpgTemplateExamples(props) {
  // Default examples for DPG with actual client examples
  const defaultExamples = [
    {
      advertiser: 'Beatrix De Musical',
      campaign: 'Theater Campaign',
      thumbnail_file_name: 'beatrix-de-musical.jpg',
      preview_url: 'https://previewer.weborama.nl/preview/0Qqy?hide_webo_label',
    },
    {
      advertiser: 'Livenation',
      campaign: 'Event Promotion',
      thumbnail_file_name: 'livenation.jpg',
      preview_url: 'https://previewer.weborama.nl/preview/D4Qn?hide_webo_label',
    },
    {
      advertiser: 'Qonto',
      campaign: 'Financial Services',
      thumbnail_file_name: 'qonto.jpg',
      preview_url: 'https://previewer.weborama.nl/preview/J5No?hide_webo_label',
    },
  ];

  const examples = props.examples && props.examples.length > 0 ? props.examples : defaultExamples;

  return (
    <div className={styles.examplesContent}>
      <div className={styles.examplesContainer}>
        <h1>Examples: Skin billboard/ APTO (970x1000)</h1>
        {examples.map((example, index) => {
          return (
            <div key={index} className={styles.exampleContainer}>
              <div className={styles.exampleContent}>
                <img
                  src={`${process.env.REACT_APP_HOST}/public/template_example_assets/${props.selectedFormat}/${example.thumbnail_file_name}`}
                  alt={`${example.advertiser} ${example.campaign} creative`}
                  onError={(e) => {
                    // Fallback to a default image if the specific image fails to load
                    // e.target.src = `${process.env.REACT_APP_HOST}/public/template_example_assets/default-placeholder.jpg`;
                  }}
                />
                <div className={styles.exampleTextContent}>
                  <div className={styles.title}>
                    <span>{example.advertiser}</span>
                  </div>
                  <div className={styles.subtitle}>{example.campaign}</div>
                  <a href={example.preview_url} target="_blank" rel="noreferrer" className={styles.link}>
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DpgTemplateExamples;
